module.exports = __webpack_public_path__ + "img/20.a574cb8a.png";